import React from "react";
import Lottie from "lottie-react";
import animation_locmvvqi from "./animation_locmvvqi.json";

const LoadingSearch = () => <Lottie animationData={animation_locmvvqi} loop={true} />;

export default LoadingSearch;